import { postFormData } from '@eika-infrastruktur/request';

import { VedleggStatusWeb } from '../generated-types';
import { CONTEXT_PATH, SERVICE_PATH } from './config';

const fullpath = `${CONTEXT_PATH}/${SERVICE_PATH}/vedlegg`;

export const uploadVedlegg = async (formData: FormData) =>
    postFormData<VedleggStatusWeb>(`${fullpath}/updateVedlegg`, formData);
